module.exports = __webpack_public_path__ + "img/home-visual-03.3815e13d.png";